







































import { Enterprise } from '@/resources/enterprise/Enterprise';
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class EnterpriseCard extends Vue {
  @Prop() public enterprise!: Enterprise;
}
